'use strict';
var parent = require('../../stable/promise');
// TODO: Remove from `core-js@4`
require('../../modules/esnext.promise.try');
require('../../modules/esnext.promise.with-resolvers');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/actual/promise/index.js
// module id = 1027
// module chunks = 0